var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home[data-v-1c8c22af]{background:url(" + escape(require("../assets/pie.png")) + ");height:85vh;padding:10%}h1[data-v-1c8c22af],h2[data-v-1c8c22af]{margin:6%}.background[data-v-1c8c22af]{background:#eee;opacity:.8;max-width:70vw;margin:0 auto;padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c8c22af","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 36
// module chunks = 0